import Splide from '@splidejs/splide';
import '../../css/frontend/blocks/gallery.css';

const carousels = document.querySelectorAll( '.wp-block-gallery-splide' );
carousels.forEach((item) =>{
	new Splide(item, {
		perPage: 1,
		perMove: 1,
		gap: 'var(--wp--preset--spacing--medium)',
		rewind : true,
		arrows: true,
		pagination: false,
		mediaQuery: 'min',
		breakpoints: {
			600: {
				perPage: 2,
			},
		}
	}).mount();
});
